'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CompactGroup(code, roles) {
  this.Ya = null;
  this.Dp = null;
  this.Ya = code;
  this.Dp = roles;
}
export { $c_Lpresto_types$CompactGroup as $c_Lpresto_types$CompactGroup };
$p = $c_Lpresto_types$CompactGroup.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CompactGroup;
/** @constructor */
function $h_Lpresto_types$CompactGroup() {
}
export { $h_Lpresto_types$CompactGroup as $h_Lpresto_types$CompactGroup };
$h_Lpresto_types$CompactGroup.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$CompactGroup)) {
    if ((this.Ya === x$0.Ya)) {
      var x = this.Dp;
      var x$2 = x$0.Dp;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "CompactGroup";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Ya;
  }
  if ((n === 1)) {
    return this.Dp;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$CompactGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jo)));
}
export { $isArrayOf_Lpresto_types$CompactGroup as $isArrayOf_Lpresto_types$CompactGroup };
var $d_Lpresto_types$CompactGroup = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CompactGroup, "presto.types$CompactGroup", ({
  jo: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$CompactGroup as $d_Lpresto_types$CompactGroup };
//# sourceMappingURL=presto.types$-Compact-Group.js.map
